/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import NProgress from 'nprogress'
import Dropdown from '../../atoms/input/Dropdown'
import ArrowRight from '../../atoms/icon/ArrowRight'
import { BaseLayout, ListViewLayout, LocalAreaLayout } from 'ui-library/dist/external/layouts'
import {
  DataTable,
  DataTableColumn as TD,
  DataTableHeader as TH,
  DataTableRow as TR,
  NavigationDrawer,
  NormalButton,
  OutlinedButton,
  SearchCheckbox,
  SearchField,
  SearchOption,
  ToolbarDateNavigation
} from 'ui-library/dist/external/components'
import Date from '../../unit/Date'
import DailyClosingAction from '../../../action/daily_closing'
import onRequestDelete from '../../../action/daily_closing/onRequestDelete'
import ClosingStatus from '../../../domain/model/closing/Status'
import { dateToStringDate } from '../../../util/DateString'
import LocalDate from '../../../domain/type/Date'
import r from '../../../util/Renderer'
import { Status, NoShow } from '../../parts/Reservation'
import { ReservationState } from '../../../store/state/ReservationState'

function ListView(props) {
  const date = props.view.date

  const paginations = {
    prev: {
      onClick: e => {
        DailyClosingAction.dateChange(date.previousDay(), props.search.search_room_ids)
      }
    },
    next: {
      onClick: e => {
        DailyClosingAction.dateChange(date.nextDay(), props.search.search_room_ids)
      }
    },
    calendar: {
      onClick: e => {},
      onDateClick: (y, m, d) => {
        DailyClosingAction.dateChange(LocalDate.of(y, m, d), props.search.search_room_ids)
      },
      selectedDate: date.toJSDate()
    }
  }

  const meta = {
    label: '',
    component: ToolbarDateNavigation,
    data: { label: dateToStringDate(date), paginations: paginations }
  }

  const toolbar = { label: `日次締め`, items: props.accountMenu }

  let index = 0
  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <BaseLayout>
        <LocalAreaLayout
          left={
            <SearchField
              name="search_keywords"
              value={props.search.search_keywords}
              onChange={DailyClosingAction.onEditSearchCondition}
              onSearch={async e => {
                NProgress.start()
                await DailyClosingAction.onRequestSearch(date, props.search)
                NProgress.done()
              }}
              searchOptions={[
                <SearchOption
                  key={1}
                  label={'宿泊施設'}
                  field={
                    <Dropdown
                      raised
                      name="search_room_ids"
                      value={props.search.search_room_ids}
                      options={props.room_options}
                      isClearable={true}
                      isMulti={true}
                      searchable={true}
                      onChange={DailyClosingAction.onEditSearchCondition}
                    />
                  }
                />,
                <SearchOption
                  key={2}
                  label={'宿泊状況'}
                  field={
                    <ul>
                      <li>
                        <SearchCheckbox label={'確認済'} name={'search_status_booked'} checked={props.search.search_status_booked} onChange={DailyClosingAction.onEditSearchCondition} />
                      </li>
                      <li>
                        <SearchCheckbox label={'キャンセル'} name={'search_status_cancelled'} checked={props.search.search_status_cancelled} onChange={DailyClosingAction.onEditSearchCondition} />
                      </li>
                      <li>
                        <SearchCheckbox
                          label={'不明'}
                          name={'search_status_not_a_reservation'}
                          checked={props.search.search_status_not_a_reservation}
                          onChange={DailyClosingAction.onEditSearchCondition}
                        />
                      </li>
                    </ul>
                  }
                />
              ]}
            />
          }
        />

        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={index++} width="90px">
                予約状況
              </TH>,
              <TH key={index++} width="220px">
                宿泊施設
              </TH>,
              <TH key={index++} width="220px">
                宿泊者名
              </TH>,
              <TH key={index++} width="250px">
                宿泊予定
              </TH>,
              <TH key={index++} width="100px">
                締め
              </TH>,
              <TH key={index++} width="150px">
                締め日
              </TH>,
              <TH key={index++} width="150px" />
            ]}
            rows={props.heads.map((head, index) => (
              <TR key={index}>
                <TD>
                  <ReservationStatus reservation={head.reservations[0]} />
                </TD>
                <TD>{head.room_name}</TD>
                <TD>{head.reservations[0].name}</TD>
                <TD>
                  <Date showYear={false}>{head.reservations[0].check_in}</Date>
                  <ArrowRight />
                  &nbsp;
                  <Date showYear={false}>{head.reservations[0].check_out}</Date>
                </TD>
                <TD>{r.renderIf(!ClosingStatus.isNone(head.status))(<HeadStatus>{head.status}</HeadStatus>)}</TD>
                <TD>
                  <Date showYear={false} link="/daily/date">
                    {head.close_date}
                  </Date>
                </TD>
                <TD>
                  {r.renderIf(!head.close_date || date.isSameDate(new LocalDate(head.close_date)))(
                    <React.Fragment>
                      {r.renderIfOrElse(head.id)(<NormalButton onClick={e => DailyClosingAction.toEditView(head.id)}> 編集 </NormalButton>)(
                        <OutlinedButton onClick={e => DailyClosingAction.addReservationEditView(date, head.room_id, head.reservations[0])}>締め処理</OutlinedButton>
                      )}
                    </React.Fragment>
                  )}
                </TD>
              </TR>
            ))}
          />
        </ListViewLayout>
      </BaseLayout>
    </React.Fragment>
  )
}

function ReservationStatus(props) {
  const { reservation } = props
  if (!reservation) {
    return ''
  }
  const r = new ReservationState(reservation)
  if (r.noshow) {
    return (
      <React.Fragment>
        <Status type={r.status}>{r.getStatusLabel()}</Status>
        <NoShow>ノーショー</NoShow>
      </React.Fragment>
    )
  }
  return <Status type={r.status}>{r.getStatusLabel()}</Status>
}

function HeadStatus(props) {
  const status = props.children

  return (
    <span className={`Status Status--${status}`}>
      <small>{ClosingStatus.getLabel(status)}</small>
    </span>
  )
}

function onConfirm(id) {
  if (window.confirm('削除しますがよろしいですか？')) {
    onRequestDelete(id)
  }
}

export default ListView
